import { DefaultPalette, transparentize } from './Colors';
export function createScrollbar(props) {
    return `
		&::-webkit-scrollbar {
			background-color: ${props.transparent ? 'transparent' : props.background};
			${props.thickness ? `width: ${props.thickness}px;` : ''}
			${props.thickness ? `height: ${props.thickness}px;` : ''}
		}
		
		&::-webkit-scrollbar-track {
			background-color: ${props.transparent ? 'transparent' : props.background};
		}
		
		&::-webkit-scrollbar-corner {
			background-color: ${props.transparent ? 'transparent' : props.background};
		}
		
		&::-webkit-scrollbar-thumb {
			background-color: ${transparentize(props.thumb, 0.7)};
			border-color: ${props.thumb};
		
			&:hover {
				background-color: ${transparentize(props.thumb, 0.5)};
			}
		}
		${props.thickness && props.thickness < 7 ? 'scrollbar-width: thin;' : ''}
	`;
}
export const createThemedScrollbars = (palette) => {
    return {
        normal: createScrollbar({
            background: palette.shade6,
            thumb: palette.secondary,
        }),
        skinny: createScrollbar({
            background: palette.shade6,
            thumb: palette.secondary,
            thickness: 6,
        }),
        transparent: (thumb) => createScrollbar({
            thumb: thumb,
            background: '',
            transparent: true,
        }),
    };
};
export const defaultScrollbars = createThemedScrollbars(DefaultPalette);
//# sourceMappingURL=Scrollbars.js.map